// extracted by mini-css-extract-plugin
export default {"CommentsButton":"im_a bik_wx bik_jb bik_xl bik_i bik_j bik_q bik_vt bik_et bik_so bik_sp bik_eg","CommentsButton__icon":"im_b bik_rz"};